import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FormControl, InputLabel } from '@mui/material';
import ButtonSwitch from './ButtonSwitch';
import styles from './VendorAttribution.module.css';

const defaultValues = {
  full_package_vendor: false,
  third_party_compliant: false,
  plus_size_manufacturer: false,
  stock_goods: false,
  fn_trim_capability: false,
  cut_to_order: false,
  exclusive_style_manufacturer: false,
  product_development_capabilities: false,
  pattern_maker: false,
};

export default function AttributeSwitches(props) {
  const {
    values: {
      full_package_vendor,
      third_party_compliant,
      third_party_garment_testing,
      plus_size_manufacturer,
      stock_goods,
      fn_trim_capability,
      cut_to_order,
      exclusive_style_manufacturer,
      product_development_capabilities,
      pattern_maker,
    } = defaultValues,
    onChange,
    emptyFields,
    disabled,
  } = props;

  return (
    <div>
      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.full_package_vendor}
        >
          <InputLabel
            htmlFor="vatt-fpv"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.full_package_vendor,
            })}
          >
            Full Package Vendor? (Design to Door - DDP/LDP)
          </InputLabel>
          <ButtonSwitch
            id="vatt-fpv"
            onChange={(selected) => onChange('full_package_vendor', selected)}
            selected={full_package_vendor}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.third_party_compliant}
        >
          <InputLabel
            htmlFor="vatt-tpc"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.third_party_compliant,
            })}
          >
            3rd Party Factory Compliant?
          </InputLabel>
          <ButtonSwitch
            id="vatt-tpc"
            onChange={(selected) => onChange('third_party_compliant', selected)}
            selected={third_party_compliant}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.third_party_garment_testing}
        >
          <InputLabel
            htmlFor="vatt-tpgt"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]:
                !!emptyFields.third_party_garment_testing,
            })}
          >
            Do you conduct 3rd Party Garment Testing?
          </InputLabel>
          <ButtonSwitch
            id="vatt-tpgt"
            onChange={(selected) =>
              onChange('third_party_garment_testing', selected)
            }
            selected={third_party_garment_testing}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.plus_size_manufacturer}
        >
          <InputLabel
            htmlFor="vatt-plus"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.plus_size_manufacturer,
            })}
          >
            Do you have a capability to produce Plus size?
          </InputLabel>
          <ButtonSwitch
            id="vatt-plus"
            onChange={(selected) =>
              onChange('plus_size_manufacturer', selected)
            }
            selected={plus_size_manufacturer}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.stock_goods}
        >
          <InputLabel
            htmlFor="vatt-fpv"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.stock_goods,
            })}
          >
            Stock Goods?
          </InputLabel>
          <ButtonSwitch
            onChange={(selected) => onChange('stock_goods', selected)}
            selected={stock_goods}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.fn_trim_capability}
        >
          <InputLabel
            htmlFor="vatt-trim"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.fn_trim_capability,
            })}
          >
            {/* eslint-disable prettier/prettier */}
            Do you have a capability to add Fashion Nova Trim to your stock
            goods?
            {/* eslint-enable prettier/prettier */}
          </InputLabel>
          <ButtonSwitch
            id="vatt-trim"
            onChange={(selected) => onChange('fn_trim_capability', selected)}
            selected={fn_trim_capability}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.cut_to_order}
        >
          <InputLabel
            htmlFor="vatt-cto"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.cut_to_order,
            })}
          >
            Cut to Order?
          </InputLabel>
          <ButtonSwitch
            id="vatt-cto"
            onChange={(selected) => onChange('cut_to_order', selected)}
            selected={cut_to_order}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.exclusive_style_manufacturer}
        >
          <InputLabel
            htmlFor="vatt-excl"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]:
                !!emptyFields.exclusive_style_manufacturer,
            })}
          >
            Can you manufacture Fashion Nova exclusive styles?
          </InputLabel>
          <ButtonSwitch
            id="vatt-exclusive"
            onChange={(selected) =>
              onChange('exclusive_style_manufacturer', selected)
            }
            selected={exclusive_style_manufacturer}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.product_development_capabilities}
        >
          <InputLabel
            htmlFor="vatt-pdc"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]:
                !!emptyFields.product_development_capabilities,
            })}
          >
            Design/Product Development Capabilities?
          </InputLabel>
          <ButtonSwitch
            id="vatt-pdc"
            onChange={(selected) =>
              onChange('product_development_capabilities', selected)
            }
            selected={product_development_capabilities}
            disabled={disabled}
          />
        </FormControl>
      </div>

      <div className={styles.switchContainer}>
        <FormControl
          variant="standard"
          required
          className={styles.buttonSwitchControl}
          error={!!emptyFields.pattern_maker}
        >
          <InputLabel
            htmlFor="vatt-pm"
            className={cx(styles.buttonSwitchLabel, {
              [styles.switchLabelError]: !!emptyFields.pattern_maker,
            })}
          >
            Pattern maker or Tech team?
          </InputLabel>
          <ButtonSwitch
            id="vatt-pm"
            onChange={(selected) => onChange('pattern_maker', selected)}
            selected={pattern_maker}
            disabled={disabled}
          />
        </FormControl>
      </div>
    </div>
  );
}

AttributeSwitches.propTypes = {
  onChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    full_package_vendor: PropTypes.bool,
    third_party_compliant: PropTypes.bool,
    plus_size_manufacturer: PropTypes.bool,
    stock_goods: PropTypes.bool,
    fn_trim_capability: PropTypes.bool,
    cut_to_order: PropTypes.bool,
    exclusive_style_manufacturer: PropTypes.bool,
    product_development_capabilities: PropTypes.bool,
    pattern_maker: PropTypes.bool,
  }),
  emptyFields: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool,
};
